<template src="./template.html"></template>

<script>
import Btn from '@/components/elements/buttons';

export default {
  name: 'Popup',
  components: { Btn },
  props: {
    isPopupSubmitDisabled: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
      default: '0px',
    },
    popupSmall: {
      type: Boolean,
      default: false,
    },
    popupMedium: {
      type: Boolean,
      default: false,
    },
    popupLarge: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: 'save',
    },
    deleteText: {
      type: String,
      default: 'delete',
    },
    cancelText: {
      type: String,
      default: 'cancel',
    },
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    downloadText: {
      type: String,
      default: 'download',
    },
    showSendButton: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    showPrintButton: {
      type: Boolean,
      default: false,
    },
    showPreviewButton: {
      type: Boolean,
      default: false,
    },
    showDownloadButton: {
      type: Boolean,
      default: false,
    },
    showDownloadDGButton: {
      type: Boolean,
      default: false,
    },
    showDownloadEODButton: {
      type: Boolean,
      default: false,
    },
    downloadDGText: {
      type: String,
      default: 'Download DG',
    },
    downloadEODText: {
      type: String,
      default: 'Download EOD',
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    deleteAction() {
      this.$emit('deleteAction');
    },
    cancel() {
      this.$emit('cancel');
    },
    print() {
      this.$emit('print');
    },
    download() {
      this.$emit('download');
    },
    downloadDG() {
      this.$emit('downloadDG');
    },
    downloadEOD() {
      this.$emit('downloadEOD');
    },
    redirect() {
      this.$emit('redirect');
    },
  },
}
</script>
